/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Registry_Isir_Open_CaseInputs */

const cs_property_registry_isir_open_case = /** @type {(inputs: Property_Registry_Isir_Open_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otevřít detail řízení`)
};

const en_property_registry_isir_open_case = /** @type {(inputs: Property_Registry_Isir_Open_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open case detail`)
};

/**
* | output |
* | --- |
* | "Open case detail" |
*
* @param {Property_Registry_Isir_Open_CaseInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_registry_isir_open_case = /** @type {((inputs?: Property_Registry_Isir_Open_CaseInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Registry_Isir_Open_CaseInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_registry_isir_open_case(inputs)
	return cs_property_registry_isir_open_case(inputs)
});